import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  ViewEncapsulation,
  inject,
  viewChild,
} from '@angular/core';
import { OspTemplateDirective } from '../../../../directives/osp-template.directive';
import { ButtonComponent } from '../../../button/button/button.component';
import { ButtonCategory } from '../../../button/button/contract/button-category.contract';
import { OspDialogConfig } from '../../dialog/contract/osp-dialog-config.contract';
import { OspDialogRef } from '../../dialog/contract/osp-dialog-ref.contract';
import { DialogComponent } from '../../dialog/dialog/dialog.component';
import { Confirmation } from '../contract/confirm-dialog-confirmation.contract';
import { ConfirmDialogResult } from '../contract/confirm-dialog-result.contract';

@Component({
  selector: 'osp-confirm-dialog-content',
  standalone: true,
  imports: [ButtonComponent, DialogComponent, OspTemplateDirective],
  templateUrl: './confirm-dialog-content.component.html',
  styleUrl: './confirm-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmDialogContentComponent implements AfterViewInit {
  @HostBinding('class.osp-confirm-dialog-content') protected readonly hostCssClassEnabled = true;

  private readonly dialogRef = inject<OspDialogRef<unknown, ConfirmDialogResult>>(OspDialogRef);
  private readonly config = inject<OspDialogConfig<Confirmation>>(OspDialogConfig);
  private readonly $acceptButton = viewChild<unknown, ElementRef<HTMLElement>>('acceptButton', { read: ElementRef });

  protected readonly message = this.config.data?.message;
  protected readonly acceptLabel = this.config.data?.acceptLabel;
  protected readonly rejectLabel = this.config.data?.rejectLabel;
  protected readonly acceptIcon = this.config.data?.acceptIcon;
  protected readonly rejectIcon = this.config.data?.rejectIcon;
  protected readonly acceptCategory: ButtonCategory = this.config.data?.acceptCategory ?? 'danger';

  public ngAfterViewInit(): void {
    this.$acceptButton()?.nativeElement.querySelector('button')?.setAttribute('autofocus', '');
  }

  protected accept(): void {
    this.dialogRef.close('accept');
  }

  protected reject(): void {
    this.dialogRef.close('reject');
  }
}
